import { useTripTypes, windowText } from "../lib/tripTypes";
import { MapPin, Moon } from "lucide-react";

export const VacationCard = ({ v, actions, highlight }) => (
  <div data-testid={`vacation-card-${v.id}`} className="lux-card overflow-hidden group hover:-translate-y-1">
    <div className="relative h-56 overflow-hidden">
      <img src={v.image_url || "https://images.unsplash.com/photo-1657829378483-2b74b43d7d9d?w=1200&q=80"} alt={v.title}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      {highlight && <span className="absolute top-4 left-4 text-[10px] font-mono-lux uppercase tracking-wider px-3 py-1 rounded-full bg-[#38BDF8] text-[#0B0F19]">Leading vote</span>}
      <span data-testid={`vacation-category-${v.id}`} className="absolute bottom-4 left-4 text-[10px] font-mono-lux uppercase tracking-wider px-3 py-1 rounded-full bg-black/70 backdrop-blur text-slate-200">{v.category}</span>
      {v.premium_only && <span data-testid={`vacation-premium-${v.id}`} className="sticker absolute bottom-4 right-4 !bg-gradient-to-r from-[#A855F7] to-[#F43F5E]">Premium</span>}
      {v.early_access && <span data-testid={`vacation-early-${v.id}`} className="sticker absolute top-4 left-4">Founder early access</span>}
      {!v.active && <span className="absolute top-4 right-4 text-[10px] font-mono-lux uppercase px-3 py-1 rounded-full bg-black/70 text-slate-300">Hidden</span>}
    </div>
    <div className="p-6">
      <h3 className="font-serif-lux text-2xl">{v.title}</h3>
      <TripWindow type={v.trip_type} id={v.id} />
      {v.broker_company && <p data-testid={`vacation-provider-${v.id}`} className="text-[11px] text-[#38BDF8] mt-1">Provided by {v.broker_company}</p>}
      <div className="flex gap-4 text-xs text-slate-400 mt-2">
        <span className="flex items-center gap-1"><MapPin className="w-3 h-3" />{v.location}</span>
        <span className="flex items-center gap-1"><Moon className="w-3 h-3" />{v.nights} nights</span>
      </div>
      <p className="text-sm text-slate-400 mt-4 leading-relaxed">{v.description}</p>
      <div className="flex flex-wrap gap-2 mt-4">
        {v.includes.map((x) => <span key={x} className="text-[11px] px-2.5 py-1 rounded-full border border-white/10 text-slate-300">{x}</span>)}
      </div>
      {actions && <div className="mt-5 flex gap-2">{actions}</div>}
    </div>
  </div>
);

const TripWindow = ({ type, id }) => {
  const tt = useTripTypes()[type || "weekend"];
  if (!tt) return null;
  return <p data-testid={`vacation-window-${id}`} className="text-[11px] font-mono-lux text-amber-200/80 mt-1">{tt.label} · {windowText(tt)}</p>;
};
